var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com__box"},[_vm._m(0),_c('div',{staticClass:"ml-2"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }